import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import DomainsTrackingEnterpriseForm from '../../../../../packages/domains-crate/components/AppDomainsTracking/AppDomainsTrackingEdit/DomainsTrackingEnterpriseForm';

const EditTrackingDomains = () => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { appId } = Route.useParams();
  return <DomainsTrackingEnterpriseForm appId={appId} />;
};

export const Route = createFileRoute('/_secured/administration/apps/$appId/data-collection/m/edit-tracking-domains')({
  component: EditTrackingDomains,
});
